import React, { useState, useEffect } from "react";
import HeaderComponent from "../../website/HeaderComponent";
import RightSectionEM from "../RightSectionEM/RightSectionEM";
import { getTeachersPipelineData } from "../../../actions/emActions";
import "./teacherPipeline.scss";

const TeacherPipeline = (props) => {
  const [teachersData, setteachersData] = useState("");
  const [classesName, setclassesName] = useState([]);
  useEffect(() => {
    getTeachersPipelineData()
      .then((res) => {
        setteachersData(res.data.result);
        console.log(res.data.result);

        // var ClassesName = Object.keys(res.data.result);
        // setclassesName(ClassesName);
        // console.log("Classes Name", ClassesName);
      })
      .catch((err) => {
        console.log(err);
        debugger;
      });
  }, []);

  const RedirectToCRM = (student) => {
    debugger;
    localStorage.setItem('searchStudent' , student);
    props.history.push('/dashboard');
  }

  return (
    <div>
      <HeaderComponent />
      <div style={{ padding: "2vh 0" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <RightSectionEM />
            </div>

            <div className="col-md-9 teacherManagement">
              <div id="accordionForTeacherManagement" class="myaccordion">
                <div id="body" className="table-responsive">
                  <table class="table">
                    <thead className="teacherManagementHeader">
                      <tr className="d-flex">
                        <th className="col-sm-2">
                          Program <br /> Name
                        </th>
                        <th className="col-sm-2">Slots</th>
                        <th
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Students already enrolled and received invoices"
                          className="col-sm-2"
                        >
                          Existing <br /> students
                        </th>
                        <th className="col-sm-2">Wait List</th>
                        <th
                          className="col-sm-2"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Students who took the demo successfully"
                        >
                          Try to <br /> convert
                        </th>
                        <th
                          className="col-sm-1"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Sum of all invoices"
                        >
                          Existing Revenue
                        </th>
                        <th className="col-sm-1">Total <br /> Signups</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(teachersData).map((item, index) => (
                        <React.Fragment key={index}>
                          <tr
                            key={index}
                            className="collapsed d-flex"
                            data-toggle="collapse"
                            data-target={`#One${index}`}
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            <td className="col-sm-2">{item}</td>
                            <td className="col-sm-2">
                              {teachersData[item]["slots_count"] &&
                                teachersData[item]["slots_count"].length}
                            </td>
                            <td className="col-sm-2">
                              {teachersData[item]["existing_students"] &&
                                teachersData[item]["existing_students"].length}
                            </td>
                            <td className="col-sm-2"> {teachersData[item]["waitng_students_count"] &&
                                teachersData[item]["waitng_students_count"]}</td>
                            <td className="col-sm-2">{teachersData[item]["try_to_convert_count"] &&
                                teachersData[item]["try_to_convert_count"]}</td>
                            <td className="col-sm-1">Rs {teachersData[item]["existing_revenue"] && teachersData[item]["existing_revenue"]['overall_amount']}</td>
                            <td className="col-sm-1">
                              {teachersData[item]["totall_singup"]}
                            </td>
                          </tr>
                          <div
                            id={`One${index}`}
                            className="collapse accordionBox"
                            aria-labelledby="headingOne"
                            data-parent="#accordionForTeacherManagement"
                          >
                            {teachersData[item]["slots_count"] &&
                              teachersData[item]["slots_count"].map(
                                (slotsName, index2) => (
                                  <tr className="d-flex" key={index2}>
                                    <th className="col-sm-2"></th>
                                    <td className="col-sm-2">
                                      <label>
                                        {index2 + 1}. {slotsName}
                                      </label>
                                    </td>
                                    <td className="col-sm-2">
                                      {teachersData[item]["teacher_students"][
                                        slotsName
                                      ] &&
                                        teachersData[item]["teacher_students"][
                                          slotsName
                                        ].map((student, index) => (
                                          <>
                                            <label style={{cursor: 'pointer'}} key={index} onClick={() => RedirectToCRM(student)}>
                                              {index + 1}. {student}
                                            </label>
                                            <br />
                                          </>
                                        ))}
                                    </td>
                                    <td className="col-sm-2">
                                      {teachersData[item]["waitng_students"][
                                        slotsName
                                      ] &&
                                        teachersData[item]["waitng_students"][
                                          slotsName
                                        ].map((student, index) => (
                                          <>
                                            <label style={{cursor: 'pointer'}} key={index} onClick={() => RedirectToCRM(student)}>
                                              {index + 1}. {student}
                                            </label>
                                            <br />
                                          </>
                                        ))}
                                    </td>
                                    <td className="col-sm-2">
                                      {teachersData[item][
                                        "try_to_convertstudents"
                                      ][slotsName] &&
                                        teachersData[item][
                                          "try_to_convertstudents"
                                        ][slotsName].map((student, index) => (
                                          <>
                                            <label style={{cursor: 'pointer'}} key={index} onClick={() => RedirectToCRM(student)}>
                                              {" "}
                                              {index + 1}. {student}
                                            </label>
                                            <br />
                                          </>
                                        ))}
                                    </td>
                                    <td className="col-sm-1">
                                      <label>
                                        Rs&nbsp;
                                        {teachersData[item]["existing_revenue"][
                                          slotsName
                                        ] &&
                                          teachersData[item][
                                            "existing_revenue"
                                          ][slotsName]}
                                      </label>
                                    </td>
                                    <td className="col-sm-1">0</td>
                                  </tr>
                                )
                              )}
                          </div>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* <div className="col-md-9">
              {Object.keys(teachersData).map((item) => (
                <React.Fragment>
                  <label>
                    Class Name: {item} Program Students:{" "}
                    {teachersData[item]["prog_students"]} Waiting List:{" "}
                    {teachersData[item]["waitng_list"]}
                  </label>
                  <br />
                  <label className="font-weight-bold">Teacher Name</label>

                  {Object.keys(teachersData[item]["slots"]).map((name) => (
                    <React.Fragment>
                      <p>{name}</p>
                      <ol>
                        {Object.keys(teachersData[item]["slots"][name]).map(
                          (teacherDetails) => (
                            <li>
                              <label>
                                {" "}
                                {teacherDetails} :{" "}
                                {
                                  teachersData[item]["slots"][name][
                                    teacherDetails
                                  ]
                                }{" "}
                              </label>
                            </li>
                          )
                        )}
                      </ol>
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherPipeline;
